import React from 'react';
var icon = require('raw-loader!svgo-loader!hudl-kickoff/icons/clip.svg');

export default (props) => {
	return (
		<div {...props} dangerouslySetInnerHTML={{__html: icon}} />
	);
	}